<template>
  <v-app style="width: 100%" class="pa-3 pt-0">
    <div class="px-3 d-flex">
      <div style="display: flex">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" icon class="float-left mt-1" small v-on="on">
              <v-icon color="primary" style="font-size: 22px" @click="print">
                mdi-cloud-print-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("print") }}</span>
        </v-tooltip>
        <v-card-text class="py-0">
          <v-chip-group
            v-model="printSize"
            active-class="deep-purple--text text--accent-4"
            mandatory
          >
            <v-chip small value="29.7cm 21cm"> A4 </v-chip>
            <v-chip small value="21cm 14.8cm"> A5 </v-chip>
            <v-chip small value="14.8cm 10.5cm"> A6 </v-chip>
            <v-chip small value="10.5cm 7.4cm"> A7 </v-chip>
            <v-chip small value="5.2cm 7.4cm"> A7 </v-chip>
            <v-chip v-if="!width && !height" small @click="customSizeDialog = true">
              {{ $t("custom") }}
            </v-chip>
            <v-chip
              v-if="width && height"
              small
              close
              color="primary"
              outlined
              @click:close="clearCustom"
              @click="customSizeDialog = true"
            >
              {{ width + "cm" }} × {{ height + "cm" }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
        <v-checkbox
          v-model="showBundleItems"
          class="mx-3 mt-1"
          style="width: 100%"
          :label="$t('showBundleItems')"
        />
      </div>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f6']"
            v-bind="attrs"
            icon
            small
            class="float-left mt-1"
            @shortkey="goTo(type)"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small class="mt-1" v-on="on" @click="edit">
            <v-icon color="primary" style="font-size: 22px"> mdi-clipboard-edit </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("edit") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="mt-1"
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("list") }} {{ $t(type) }}</span>
      </v-tooltip>
    </div>
    <div id="print" class="px-3">
      <v-data-table
        v-if="tableHeaders"
        ref="table"
        :headers="tableHeaders"
        :items="items"
        :items-per-page="8000000000000"
        hide-default-footer
      >
        <template v-slot:item.row="{ item }">
          <div align="center">
            {{ parseInt(items.indexOf(item)) + parseFloat(1) }}
          </div>
        </template>
        <!--        <template-->
        <!--          slot="header"-->
        <!--          :headers="headers"-->
        <!--        >-->
        <!--          <tr>-->
        <!--            <th-->
        <!--              v-for="header in headers"-->
        <!--              :key="header.value"-->
        <!--              class="py-3"-->
        <!--              style="border-bottom: 1px solid #e3e3e3;font-size: 12px;color: gray"-->
        <!--            >-->
        <!--              {{header.text}}-->
        <!--            </th>-->
        <!--          </tr>-->
        <!--          <v-divider></v-divider>-->
        <!--        </template>-->
        <template v-slot:item.unit.fame="{ item }">
          {{
            item.unit
              ? item.unit.fame
              : item.product && item.product.unit
              ? item.product.unit.fame
              : ""
          }}
          {{
            item.product.unit_default
              ? "(" +
                toFixedWithoutZeros(
                  parseFloat(item.count) / parseFloat(item.product.unit_default.value),
                  2
                ) +
                " " +
                item.product.unit_default.unit.fame +
                ")"
              : ""
          }}
        </template>
        <template v-slot:item.product="{ item }">
          <div align="center">
            {{ item.product.name }}
            <span
              style="
                display: inline-flex;
                gap: 2px;
                flex-wrap: wrap;
                justify-content: center;
              "
            >
              <v-chip
                v-for="(tag, index) in item.product.tags"
                :key="index"
                small
                outlined
              >
                <span class="ml-2"> {{ tag.text }}</span>
              </v-chip>
            </span>
          </div>
          <div v-if="item.bundleItems && showBundleItems" class="my-2">
            <v-simple-table
              dense
              class="px-3"
              style="min-height: 10px !important; background-color: #e3e3e3"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("bundleProducts") }}
                    </th>
                    <th class="text-center">
                      {{ $t("count") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(article, i) in item.bundleItems" :key="i">
                    <td class="text-center">
                      {{ article.product.name }}
                    </td>
                    <td class="text-center">
                      {{ article.count * item.count }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>
        <template v-slot:item.count="{ item }">
          <div align="center">
            {{
              $numberFormat(parseFloat(item.countUnit ? item.countUnit : item.count), 10)
            }}
          </div>
        </template>
        <template v-slot:item.content="{ item }">
          <div v-if="item.content && item.content != 0" align="center">
            {{ item.content }}
          </div>
        </template>
        <template v-slot:body.append>
          <template v-if="isWarehouseHandlingPrint">
            <tr>
              <td colspan="2">
                <strong>{{ $t("sum") }}</strong>
              </td>
              <td>
                <div align="center">{{ $numberFormat(totals.count) }}</div>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-if="content">
              <td colspan="6">{{ $t("content") }} : {{ content }}</td>
            </tr>
            <tr>
              <td colspan="3">
                <div align="center">{{ $t("delivererSignature") }}</div>
              </td>
              <td colspan="3">
                <div align="center">{{ $t("recipientSignature") }}</div>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr :class="{ 'v-data-table__mobile-table-row': isMobile }">
              <td
                :colspan="`${isMobile ? 6 : 2}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              >
                <strong>{{ $t("sum") }}</strong>
              </td>
              <td
                :colspan="`${isMobile ? 6 : 1}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              >
                <div align="center">
                  {{ isMobile ? $t("count") + ":" : "" }}
                  {{ $numberFormat(totals.count) }}
                </div>
              </td>
              <td
                :colspan="`${isMobile ? 6 : 2}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              />
            </tr>
            <tr>
              <td
                :colspan="`${isMobile ? 6 : 5}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              >
                {{ $t("content") }} : {{ content }}
              </td>
            </tr>
            <tr>
              <td
                :colspan="`${isMobile ? 6 : 3}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              >
                <div align="center">
                  {{ $t("delivererSignature") }}
                </div>
              </td>
              <td
                :colspan="`${isMobile ? 6 : 2}`"
                :class="{ 'v-data-table__mobile-row': isMobile }"
              >
                <div align="center">
                  {{ $t("recipientSignature") }}
                </div>
              </td>
            </tr>
          </template>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="customSizeDialog"
      width="60%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="customSizeDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print-size") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="setCustomeSize">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import store from "../../../../store";
import General from "../../../../Mixins/general";
export default {
  mixins: [General],
  props: ["headerProp", "itemsProp", "title", "idProp"],
  data() {
    return {
      headerPrint: [],
      items: [],
      showBundleItems: true,
      type: null,
      content: null,
      id: null,
      date: null,
      account: null,
      number: null,
      currency_amount: null,
      dueDate: null,
      currency: null,
      tax: null,
      discount: null,
      entrepot: null,
      totalTax: null,
      totalDiscount: null,
      totalCount: null,
      totalFee: null,
      sum: null,
      width: null,
      height: null,
      user: null,
      recipientEntrepot: null,
      invoice: null,
      self: null,
      headers: null,
      customSizeDialog: null,
      printSize: "29.7cm 21cm",
    };
  },
  computed: {
    isWarehouseHandlingPrint() {
      return this.$route.name === "warehouseHandlingPrint";
    },
    tableHeaders() {
      if (this.isWarehouseHandlingPrint) {
        return [
          {
            text: this.$t("row"),
            align: "start",
            sortable: false,
            value: "row",
            width: 20,
          },
          { text: this.$t("product"), sortable: true, value: "product", align: "center" },
          {
            text: this.$t("counting_final"),
            sortable: true,
            value: "count",
            align: "center",
          },
          {
            text: this.$t("counting_one"),
            sortable: true,
            value: "counting_one",
            align: "center",
          },
          {
            text: this.$t("counting_two"),
            sortable: true,
            value: "counting_two",
            align: "center",
          },
          {
            text: this.$t("content"),
            sortable: false,
            value: "content",
            align: "center",
          },
        ];
      }
      return this.headers;
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.count += parseFloat(d.countUnit ? d.countUnit : d.count);
          acc.fee += parseFloat(d.fee) * parseFloat(d.count);
          acc.discount += parseFloat(d.discount);
          acc.tax += parseFloat(d.tax);
          return acc;
        },
        {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    idProp() {
      this.id = this.idProp;
    },
    headerProp() {
      // this.head = this.itemsProp
    },
    itemsProp() {
      this.items = this.itemsProp;
    },
  },
  beforeMount() {
    this.headers = [
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("product"),
        sortable: true,
        value: "product",
        align: "center",
      },
      {
        text: this.$t("count"),
        sortable: true,
        value: "count",
        align: "center",
      },
      {
        text: this.$t("unit"),
        sortable: true,
        value: "unit.fame",
        align: "center",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        align: "center",
      },
    ];
    var storage = JSON.parse(localStorage.getItem("token"));
    if (storage != null) {
      store.commit("SET_START_DATE", storage.init.startDate);
      store.commit("SET_END_DATE", storage.init.endDate);
      store.commit("SET_DATE_LOCALE", storage.init.date_locale.value);
      if (storage.init.date_locale.value === "fa,en") {
        store.commit("SET_DATE_FORMAT", "jYYYY/jMM/jDD");
      } else {
        store.commit("SET_DATE_FORMAT", "YYYY/MM/DD");
        store.commit("SET_START_DATE", null);
        store.commit("SET_END_DATE", null);
      }
      store.commit("SET_RTL", storage.init.rtl.value);
      store.commit("SET_DARK", storage.init.dark.value);
      store.commit("SET_LANG", storage.init.lang.value);
      store.commit("SET_THEME_COLOR", storage.init.theme_color.value);
    }
    this.$vuetify.theme.dark = this.$store.state.dark;
    this.$root.$i18n.locale = this.$store.state.lang;
    this.$vuetify.theme.themes[
      this.$vuetify.theme.isDark ? "dark" : "light"
    ].primary = this.$store.state.theme_color;
    if (this.$store.state.rtl) {
      this.$vuetify.rtl = true;
      storage.init.rtl.value = true;
      localStorage.setItem("token", JSON.stringify(storage));
    } else {
      this.$vuetify.rtl = false;
    }
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    if (this.id) {
      this.show();
    }
  },
  mounted() {},
  methods: {
    edit() {
      this.$router.push({ name: this.type + "Edit", params: { id: this.id } });
    },
    setheader(data) {
      const headerColspan = this.isWarehouseHandlingPrint ? 6 : 5;

      var elm = this.$refs.table.$el.querySelector(".v-data-table-header");
      var tr1 = document.createElement("tr");
      var tr2 = document.createElement("tr");
      // tr1.innerHTML = '' +
      //   '<th colspan="3">' +
      //   '<div align="right"><img class="mx-1" src="' + this.self.logo.link + '" width="50"></div>' +
      //   '</th>' +
      //   '<th colspan="3">' +
      //   '<div align="center" style="font-size: 16px">' + this.$t('print') + ' ' + this.$t(this.type) + ' </div>' +
      //   '<div align="center"> ' + this.self.abrName + '</div>' +
      //   '</th>' +
      //   '<th colspan="2">' +
      //   '<div align="left">' + this.$t('date') + ': ' + this.date + ' </div>' +
      //   '<div align="left">' + this.$t('number') + ': ' + this.number + ' </div>' +
      //   '<div align="left">' + this.$t('registerar') + ': ' + this.user.name + ' </div>' +
      //   '</th>'
      tr1.innerHTML =
        "" +
        '<th colspan="' +
        headerColspan +
        '">' +
        '<div style="display: flex">' +
        '<div style="width: 33.33%">' +
        '<div align="right"><img class="mx-1" src="' +
        (this.self.logo ? this.self.logo.link : "") +
        '" width="50"></div>' +
        "</div>" +
        '<div style="width: 33.33%">' +
        '<div align="center" style="font-size: 16px">' +
        this.$t("print") +
        " " +
        this.$t(this.type) +
        " </div>" +
        '<div align="center"> ' +
        this.self.abrName +
        "</div>" +
        "</div>" +
        '<div style="width: 33.33%">' +
        '<div align="left">' +
        this.$t("date") +
        ": " +
        this.date +
        " </div>" +
        '<div align="left">' +
        this.$t("number") +
        ": " +
        this.number +
        " </div>" +
        '<div align="left">' +
        this.$t("registerar") +
        ": " +
        this.user.name +
        " </div>" +
        '<div align="left">' +
        this.$t("printBy") +
        ": " +
        this.$store.state.fullname +
        " </div>" +
        "</div>" +
        "</div>" +
        "</th>";
      tr2.innerHTML =
        "" +
        '<th colspan="' +
        headerColspan +
        '" style="padding: 6px 0px">' +
        '<div align="right">' +
        this.$t("originWarehouse") +
        ": " +
        this.entrepot.name +
        " </div>" +
        '<div align="right">' +
        this.$t("destinationWarehouse") +
        ": " +
        (this.recipientEntrepot ? this.recipientEntrepot.name : "") +
        " </div>" +
        '<div align="right">' +
        this.$t("relative-document") +
        ": " +
        (this.invoice ? this.invoice.name : "") +
        " </div>" +
        '<div align="right">' +
        this.$t("detailsAddress") +
        ": " +
        (this.invoice && this.invoice.customer && this.invoice.customer.address
          ? this.invoice.customer.address
          : "-") +
        " </div>" +
        "</th>";
      elm.prepend(tr2);
      elm.prepend(tr1);
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "entrepot/" + app.id + "/edit", {
          params: {
            id: app.id,
            print: "active",
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.type = res.type;
            app.id = res.id;
            app.number = res.id;
            app.user = res.user;
            app.entrepot = res.entrepot;
            app.recipientEntrepot = res.recipient_entrepot;
            app.relations = res.invoice;
            app.items = res.articles;
            app.date = res.date;
            app.content = res.content;
            app.invoice = res.invoice;
            app.self = res.self;
            app.status = res.last_status ? res.last_status.status : null;
            var printData = {
              title: this.title,
              user: this.$store.state.full_name,
            };
            app.setheader(printData);
            setTimeout(function () {
              app.render = true;
            }, 2000);
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    clearCustom() {
      this.height = null;
      this.width = null;
    },
    setCustomeSize() {
      this.printSize = this.width + "cm " + this.height + "cm";
      this.customSizeDialog = false;
    },
    print() {
      var direction = "ltr";
      if (this.$vuetify.rtl) {
        direction = "rtl";
      }
      var style =
        "<style>" +
        // '@page { size: ' + this.printSize + '}' +
        // '@media print {html, body {zoom: 75%}}' +
        "@media print {" +
        "body { padding: 10px; box-sizing: border-box; }" +
        "}" +
        "@bottom-left {content: normal;margin: 0;}}" +
        "</style>";
      setTimeout(function () {
        // Get HTML to print from element
        const prtHtml = document.getElementById("print").innerHTML;

        let stylesHtml = "";
        let node = null;
        for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }

        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0"
        );
        WinPrint.document.write(
          "<!DOCTYPE html> <html> <head> " +
            stylesHtml +
            " " +
            style +
            ' </head> <body style="direction: ' +
            direction +
            '">' +
            prtHtml +
            " </body> </html>"
        );
        WinPrint.document.close();
        WinPrint.focus();
        setTimeout(function () {
          WinPrint.print();
          WinPrint.close();
        }, 2000);
      }, 50);
    },
  },
};
</script>

<style scoped>
@media print {
  html,
  body {
    width: 143mm;
    height: 70mm;
  }
}
</style>
<style lang="sass">
.v-data-table__wrapper
  min-height: 50px !important
</style>
